import React from 'react';
import { SearchOutlined } from '@ant-design/icons';

/**
 * UISearchBar - Search Bar molecule component
 */
const UISearchBar = ({
    placeholder = 'Search...',
    variant = 'default',
    state = 'default',
    deviceType = 'mobile',
    tokens
}) => {
    const primaryColor = tokens?.colors?.find(c => c.name === 'primary')?.value || '#1677ff';

    // Get typography from tokens
    const bodyTypo = tokens?.typography?.find(t => t.name === 'body')
        || { fontFamily: 'Inter, system-ui, sans-serif', weight: 400, sizes: { mobile: 14, tablet: 14, desktop: 14 } };
    const buttonTypo = tokens?.typography?.find(t => t.name === 'button') || bodyTypo;

    const fontSize = bodyTypo.sizes?.[deviceType] || bodyTypo.sizes?.mobile || 14;

    return (
        <div style={{
            width: '100%',
            height: '100%',
            background: '#0d1117',
            border: '1px solid #30363d',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            padding: '0 12px',
            gap: 8
        }}>
            <SearchOutlined style={{ color: '#484f58', fontSize: 16 }} />
            <span style={{
                flex: 1,
                color: '#484f58',
                fontSize: fontSize,
                fontFamily: bodyTypo.fontFamily || 'Inter, system-ui, sans-serif'
            }}>
                {placeholder}
            </span>
            {variant === 'with-button' && (
                <div style={{
                    background: primaryColor,
                    color: '#ffffff',
                    padding: '6px 12px',
                    borderRadius: 4,
                    fontSize: 12,
                    fontFamily: buttonTypo.fontFamily || 'Inter, system-ui, sans-serif',
                    fontWeight: buttonTypo.weight || 500
                }}>
                    Search
                </div>
            )}
        </div>
    );
};

export default UISearchBar;
